import { createFileRoute, redirect } from "@tanstack/react-router"

// Port of app/e2e/[userId]/dead-leads/page.tsx (was `redirect(/e2e/<uid>/tasks)`).
export const Route = createFileRoute("/e2e/$userId/dead-leads")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/e2e/${params.userId}/tasks` })
  },
})
